type ProgressCallback = (percent: number) => void;

export type MonotonicProgressCallback = ProgressCallback & {
  readonly current: number;
};

export const createMonotonicProgress = (
  onProgress?: ProgressCallback,
): MonotonicProgressCallback => {
  let max = 0;

  const report = ((percent: number) => {
    max = Math.max(max, percent);
    onProgress?.(max);
  }) as MonotonicProgressCallback;

  Object.defineProperty(report, "current", {
    get: () => max,
  });

  return report;
};

export const createScopedProgress = (
  onProgress: ProgressCallback | undefined,
  start: number,
  end: number,
): ((fraction: number) => void) => {
  if (!onProgress) return () => undefined;

  const range = end - start;
  return (fraction: number) => {
    const clamped = Math.max(0, Math.min(1, fraction));
    onProgress(Math.round(start + clamped * range));
  };
};
